import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export class EpisodeService {
	public static episodeSave(input: any) {
		return input.episode.episodeId >= 0 ?
			Http.axios().put('/api/Episode/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {return res;})
				.catch((e: any) => { return e.response; })
			:
			Http.axios().post('/api/Episode/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })		
				.then((res: any) => {return res;})
				.catch((e: any) => { return e.response; });	
	}

	public static episodeGetByFilter(input: any) {
		if (input.channelIds.length === 1 && input.channelIds[0] === 0) {
			input.channelIds = [];
		}
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Episode/getbyfilter', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeGetDetail(id: any) {
		return Http.axios().get('/api/Episode/details/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeGetMinDate() {
		return Http.axios().get('/api/Episode/getminmaxdate/', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeTypeGetByFilter() {
		return Http.axios().get('/api/EpisodeType/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static bookMarkTypeGetByFilter() {
		return Http.axios().get('/api/BookMarkType/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeDelete(input: any) {
		return Http.axios().delete('/api/Episode/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeGetReadingIdByTitle(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Reading/getreadingid', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeGetReading(input: any) {
		return Http.axios().post('/api/Reading/getreadingforepisode', input, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeGetUserCountByYear(input: any) {
		return Http.axios().get('api/Episode/getuserepisodecountbyyear?year=' + input.year + '&userId=' + input.userId, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeGetUserEngagement(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Episode/GetEpisdeEngagementByUserFilter', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
	public static episodeValidateFeed() {
		//var obj = JSON.stringify(inputDateAtUtc);
		return Http.axios().post('/api/Episode/EpisodeValidateFeed', null, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static getUserEpisodeMetric() {
		return Http.axios().get('/api/Episode/getUserEpisodeMetrics', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static episodeUpdateEngagement(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().put('/api/Episode/UpdateEpisodeEngagement', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

}